import React, { useEffect, useState } from "react";
import "./Withdraw_bank_info.css";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import { AppSetup } from "../../../features/admin/common/Slice";
import { WithdrawAmount } from "../../../features/wallet/slice";
import { formatAmount, formatTimeAMPM } from "../../../utils/common";
import Successfull_strip_modal from "../../Common/Common_Component/Common_Modal/Successfull_strip_modal/Successfull_strip_modal";
import { GETAuthLogin } from "../../../features/auth/Slice";

function Withdraw_bank_info() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const selectedBank = useSelector((state) => state.wallet.selectedBank);
  const allBanks = useSelector((state) => state.wallet.banks);
  const { balance } = useSelector((state) => state.wallet);
  const appSetup = useSelector((state) => state.common.app_setup);

  const [modalShow, setModalShow] = useState(false);
  const [modalMessage, setModalMessage] = useState("Successful");

  const {
    register,
    handleSubmit,
    setValue,
    watch,
    reset,
    formState: { errors, isSubmitting },
  } = useForm({
    defaultValues: { amount: "" },
  });

  useEffect(() => {
    dispatch(AppSetup());
  }, [dispatch]);

  const amountValue = watch("amount");

  const handleAll = () => {
    setValue("amount", balance ?? 0, { shouldValidate: true });
  };

  const onSubmit = async (data) => {
    // No bank — redirect to select one
    if (!selectedBank?.id) {
      navigate("/bank-account");
      return;
    }

    try {
      const formData = new FormData();
      formData.append("amount", data?.amount);
      formData.append("bank_id", selectedBank?.id);

      const res = await dispatch(WithdrawAmount(formData));

      if (res.meta?.requestStatus === "fulfilled") {
        setModalMessage(res?.payload?.data || "Withdraw request submitted!");
        setModalShow(true);
        reset();
        setTimeout(() => {
          setModalShow(false);
          navigate("/account");
        }, 3000);
      } else {
        setModalMessage(res?.payload?.errors || "Withdraw failed. Try again.");
        setModalShow(true);
        setTimeout(() => setModalShow(false), 3000);
      }
    } catch (error) {
      console.error("Withdraw error:", error);
    }
  };

  // No banks added at all
  const noBanksAdded = allBanks?.length === 0;
  // Banks exist but none selected
  const noBankSelected = !selectedBank?.id && allBanks?.length > 0;

  const user = useSelector((state) => state.auth.data);

  useEffect(() => {
    dispatch(GETAuthLogin());
  }, [dispatch]);

  return (
    <section className="Withdraw_bank_info">
      <div className="withdraw_card">
        <div className="heading_text_holder">Please enter the amount</div>

        {/* No banks added */}
        {noBanksAdded && (
          <div
            className="no_bank_warning"
            onClick={() => navigate("/add-bank-account")}
            style={{
              cursor: "pointer",
              color: "#fc5c5d",
              fontSize: "13px",
              marginBottom: "10px",
            }}
          >
            ⚠ You have no bank accounts.{" "}
            <span style={{ textDecoration: "underline" }}>
              Add a bank account
            </span>
          </div>
        )}

        {/* Banks exist but none selected */}
        {noBankSelected && (
          <div
            className="no_bank_warning"
            onClick={() => navigate("/bank-account")}
            style={{
              cursor: "pointer",
              color: "#fc5c5d",
              fontSize: "13px",
              marginBottom: "10px",
            }}
          >
            ⚠ No bank account selected.{" "}
            <span style={{ textDecoration: "underline" }}>
              Click here to select
            </span>
          </div>
        )}

        <form onSubmit={handleSubmit(onSubmit)} noValidate>
          {/* Amount Input */}
          <div className="amount_input">
            <span className="rupee">₹</span>
            <input
              type="number"
              placeholder="Please enter withdrawal amount"
              {...register("amount", {
                required: "Please enter an amount",
                min: {
                  value: appSetup?.min_amount ?? 110,
                  message: `Minimum withdrawal is ₹${appSetup?.min_amount ??
                    110}`,
                },
                max: {
                  value: appSetup?.max_amount ?? 10000000,
                  message: `Maximum withdrawal is ₹${appSetup?.max_amount ??
                    10000000}`,
                },
              })}
            />
          </div>
          {errors.amount && (
            <small className="text-danger d-block mb-2">
              {errors.amount.message}
            </small>
          )}

          {/* Submit */}
          <button
            type="submit"
            className={
              amountValue && selectedBank?.id ? "btn_register_bg" : "gray_btn"
            }
            disabled={isSubmitting || !selectedBank?.id}
          >
            {isSubmitting ? "Processing..." : "Withdraw"}
          </button>
        </form>

        {/* Info */}
        <div className="Withdraw_deposite_bank_info mt-3">
          <div className="info_box">
            <p>
              <span className="red">•</span> Need to bet{" "}
              <span className="red">
                {formatAmount(user?.min_withdraw_bet_amount) ?? "0.00"}
              </span>{" "}
              to be able to withdraw
            </p>
            <p>
              <span className="red">•</span> Withdraw time{" "}
              <span className="red">
                {formatTimeAMPM(appSetup?.wd_start_time)} -{" "}
                {formatTimeAMPM(appSetup?.wd_end_time)}
              </span>
            </p>
            <p>
              <span className="red">•</span> In day Remaining Withdrawal{" "}
              <span className="red">
                Times {appSetup?.withdraw_limit_per_day ?? 3}
              </span>
            </p>
            <p>
              <span className="red">•</span> Withdrawal amount range{" "}
              <span className="red">
                {formatAmount(appSetup?.wd_amount_start) ?? "110.00"} —{" "}
                {formatAmount(appSetup?.wd_amount_end) ?? "10,000,000.00"}
              </span>
            </p>
          </div>
        </div>
      </div>

      <Successfull_strip_modal
        show={modalShow}
        onHide={() => setModalShow(false)}
        textMsg={modalMessage}
      />
    </section>
  );
}

export default Withdraw_bank_info;
